import Subject from "../util/Subject";
import clsMerge from "../util/clsMerge";
import Circle from "./decorations/Circle";
import DotsGrid from "./decorations/DotsGrid";

export const SUBJECT_STYLES = {
	[Subject.MATH]: {
		background: "xl:bg-navy-100",
		circle: "from-transparent to-[#389] opacity-20",
		dots: "fill-midtone-blue opacity-50",
	},
	[Subject.LANGUAGE_ARTS]: {
		background: "xl:bg-orange-100",
		circle: "from-transparent to-[#a42] opacity-20",
		dots: "fill-rich-orange opacity-60",
	},
	[Subject.SCIENCE]: {
		background: "xl:bg-green-100",
		circle: "from-transparent to-green-300",
		dots: "fill-green-500",
	},
	[Subject.COMPUTER_SCIENCE]: {
		background: "xl:bg-gray-100",
		circle: "from-transparent to-gray-300",
		dots: "fill-gray-500",
	},
};

const CourseShelfDecorations: React.FC<{subject: Subject}> = ({subject}) => {
	const styles = SUBJECT_STYLES[subject];
	return (
		<div className="pointer-events-none absolute left-0 top-0 hidden h-full w-full xl:block">
			<Circle
				className={clsMerge(
					"absolute bottom-0 right-0 translate-x-1/4 translate-y-[60%] scale-150 bg-gradient-to-t",
					styles.circle
				)}
			/>
			<DotsGrid
				className={clsMerge(
					"absolute bottom-6 right-[250px] -scale-y-75 scale-x-75"
				)}
				dotClassName={styles.dots}
			/>
		</div>
	);
};

export default CourseShelfDecorations;
